import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { authenticateSiga } from '../actions/authenticationJwtActions'

export class Login extends Component {
  componentDidMount() {
    const { isUserAuthenticated } = this.props.authentication
    if (!isUserAuthenticated) {
      const { from } = this.props.location.state || { from: { pathname: '/', search: '' } }
      const redirectTo = `${from.pathname}${from.search}`
      this.props.authenticateSiga(window.location.origin, encodeURI(redirectTo))
    }
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } }
    const { isUserAuthenticated } = this.props.authentication

    return isUserAuthenticated ? <Redirect to={from} /> : null
  }
}

const mapStateToProps = ({ authentication }) => ({ authentication })

export default connect(mapStateToProps, { authenticateSiga })(Login)
